import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const fixtureNewsStyles = style({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  gap: vars.space.m,
  padding: vars.space.m,
  maxWidth: 230,
});
